import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type BulkOrderDeleteJobSummaryFragment = { __typename?: 'BulkOrderDeleteJobDocument', jobId: string, status: Types.BulkOrderDeleteJobStatus, createdAt: Types.TDateISO, startedAt?: Types.TDateISO | null, completedAt?: Types.TDateISO | null, totalCount: number, processedCount: number, deletedCount: number, failedCount: number };

export type GetBulkOrderDeleteJobQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type GetBulkOrderDeleteJobQuery = { __typename?: 'Query', bulkOrderDeleteJob?: { __typename?: 'BulkOrderDeleteJobDocument', jobId: string, status: Types.BulkOrderDeleteJobStatus, createdAt: Types.TDateISO, startedAt?: Types.TDateISO | null, completedAt?: Types.TDateISO | null, totalCount: number, processedCount: number, deletedCount: number, failedCount: number } | null };

export type GetBulkOrderDeleteJobResultsQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type GetBulkOrderDeleteJobResultsQuery = { __typename?: 'Query', bulkOrderDeleteJob?: { __typename?: 'BulkOrderDeleteJobDocument', jobId: string, status: Types.BulkOrderDeleteJobStatus, createdAt: Types.TDateISO, startedAt?: Types.TDateISO | null, completedAt?: Types.TDateISO | null, totalCount: number, processedCount: number, deletedCount: number, failedCount: number, results: Array<{ __typename?: 'BulkOrderDeleteResultData', orderId: string, orderNumber?: string | null, success: boolean, reason?: string | null }> } | null };

export type GetUnfinishedBulkOrderDeleteJobsQueryVariables = Types.Exact<{
  where: Types.BulkOrderDeleteJobDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetUnfinishedBulkOrderDeleteJobsQuery = { __typename?: 'Query', bulkOrderDeleteJobs?: { __typename?: 'BulkOrderDeleteJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'BulkOrderDeleteJobDocument', jobId: string, status: Types.BulkOrderDeleteJobStatus, createdAt: Types.TDateISO, startedAt?: Types.TDateISO | null, completedAt?: Types.TDateISO | null, totalCount: number, processedCount: number, deletedCount: number, failedCount: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetBulkOrderDeleteFailedOrdersQueryVariables = Types.Exact<{
  where: Types.OrdersDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetBulkOrderDeleteFailedOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string, customerName: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const BulkOrderDeleteJobSummaryFragmentDoc = new TypedDocumentString(`
    fragment BulkOrderDeleteJobSummary on BulkOrderDeleteJobDocument {
  jobId
  status
  createdAt
  startedAt
  completedAt
  totalCount
  processedCount
  deletedCount
  failedCount
}
    `, {"fragmentName":"BulkOrderDeleteJobSummary"});
export const GetBulkOrderDeleteJobDocument = new TypedDocumentString(`
    query GetBulkOrderDeleteJob($jobId: String!) {
  bulkOrderDeleteJob(jobId: $jobId) {
    ...BulkOrderDeleteJobSummary
  }
}
    fragment BulkOrderDeleteJobSummary on BulkOrderDeleteJobDocument {
  jobId
  status
  createdAt
  startedAt
  completedAt
  totalCount
  processedCount
  deletedCount
  failedCount
}`);
export const GetBulkOrderDeleteJobResultsDocument = new TypedDocumentString(`
    query GetBulkOrderDeleteJobResults($jobId: String!) {
  bulkOrderDeleteJob(jobId: $jobId) {
    ...BulkOrderDeleteJobSummary
    results {
      orderId
      orderNumber
      success
      reason
    }
  }
}
    fragment BulkOrderDeleteJobSummary on BulkOrderDeleteJobDocument {
  jobId
  status
  createdAt
  startedAt
  completedAt
  totalCount
  processedCount
  deletedCount
  failedCount
}`);
export const GetUnfinishedBulkOrderDeleteJobsDocument = new TypedDocumentString(`
    query GetUnfinishedBulkOrderDeleteJobs($where: BulkOrderDeleteJobDocumentFilterInput!, $first: Int!) {
  bulkOrderDeleteJobs(first: $first, where: $where) {
    nodes {
      ...BulkOrderDeleteJobSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment BulkOrderDeleteJobSummary on BulkOrderDeleteJobDocument {
  jobId
  status
  createdAt
  startedAt
  completedAt
  totalCount
  processedCount
  deletedCount
  failedCount
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetBulkOrderDeleteFailedOrdersDocument = new TypedDocumentString(`
    query GetBulkOrderDeleteFailedOrders($where: OrdersDocumentFilterInput!, $first: Int!) {
  orders(where: $where, first: $first) {
    nodes {
      orderId
      orderNumber
      customerName
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetBulkOrderDeleteJob: build.query<GetBulkOrderDeleteJobQuery, GetBulkOrderDeleteJobQueryVariables>({
      query: (variables) => ({ document: GetBulkOrderDeleteJobDocument, variables })
    }),
    GetBulkOrderDeleteJobResults: build.query<GetBulkOrderDeleteJobResultsQuery, GetBulkOrderDeleteJobResultsQueryVariables>({
      query: (variables) => ({ document: GetBulkOrderDeleteJobResultsDocument, variables })
    }),
    GetUnfinishedBulkOrderDeleteJobs: build.query<GetUnfinishedBulkOrderDeleteJobsQuery, GetUnfinishedBulkOrderDeleteJobsQueryVariables>({
      query: (variables) => ({ document: GetUnfinishedBulkOrderDeleteJobsDocument, variables })
    }),
    GetBulkOrderDeleteFailedOrders: build.query<GetBulkOrderDeleteFailedOrdersQuery, GetBulkOrderDeleteFailedOrdersQueryVariables>({
      query: (variables) => ({ document: GetBulkOrderDeleteFailedOrdersDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetBulkOrderDeleteJobQuery, useLazyGetBulkOrderDeleteJobQuery, useGetBulkOrderDeleteJobResultsQuery, useLazyGetBulkOrderDeleteJobResultsQuery, useGetUnfinishedBulkOrderDeleteJobsQuery, useLazyGetUnfinishedBulkOrderDeleteJobsQuery, useGetBulkOrderDeleteFailedOrdersQuery, useLazyGetBulkOrderDeleteFailedOrdersQuery } = injectedRtkApi;
